/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import { type MenuOptionTyping, type NavigationButtonTyping } from '@/typings/widget';
import { type ComputedRef, type Ref } from 'vue';

// eslint-disable-next-line max-lines-per-function, max-statements
export const useWidgetMenuStore = defineStore('menu', () => {
    const { t } = useI18n();

    // Store
    const { isContactActive, isAppointmentActive } = storeToRefs(useWidgetVenueStore());
    const { venueWidgetParts } = storeToRefs(useWidgetVenueStore());

    // Constants
    const MENU_ITEM_PARTS = [
        {
            widgetPartId: 3,
            menuIndex: 0,
        }, // quote
        {
            widgetPartId: 4,
            menuIndex: 1,
        }, // packages
        {
            widgetPartId: 2,
            menuIndex: 2,
        }, // journey
    ];

    // State
    const isMenuOpen: Ref<boolean> = ref(false);
    const isQuoteOpen: Ref<boolean> = ref(false);

    // Getters
    const menuOptions: ComputedRef<MenuOptionTyping[]> = computed(() => {
        // Build inside the computed so titles/descriptions re-translate when the locale changes
        const menuItems: MenuOptionTyping[] = [
            {
                value: 'quote',
                title: t('widget.selection.quote'),
                desc: t('widget.selection.quote-desc'),
            },
            {
                value: 'packages',
                title: t('widget.selection.packages'),
                desc: t('widget.selection.packages-desc'),
            },
            {
                value: 'journey',
                title: t('widget.selection.journey'),
                desc: t('widget.selection.journey-desc-2'),
            },
        ];
        const activeParts = new Set(venueWidgetParts.value
            .filter(part => part.activated)
            .map(part => part.widgetPartId));
        return MENU_ITEM_PARTS
            .filter(({ widgetPartId }) => activeParts.has(widgetPartId))
            .map(({ menuIndex }) => menuItems[menuIndex]);
    });
    const navigationButtons: ComputedRef<NavigationButtonTyping[]> = computed(() => [
        {
            key: 'appointment',
            pageName: t('widget.navigation.appointment'),
            mainIcon: 'dateOutlined',
            secondaryIcon: 'dateFilled',
            event: 'appointmentSelected',
            activated: isAppointmentActive.value,
        },
        {
            key: 'contact',
            pageName: t('widget.navigation.contact'),
            mainIcon: 'chatOutlined',
            secondaryIcon: 'chatFilled',
            event: 'contactSelected',
            activated: isContactActive.value,
        },
        {
            key: 'call',
            pageName: t('widget.navigation.call'),
            mainIcon: 'callOutlined',
            secondaryIcon: 'callFilled',
            event: 'callSelected',
            activated: true,
        },
    ]);

    return {
        isMenuOpen,
        isQuoteOpen,
        menuOptions,
        navigationButtons,
    };
});
